'use client';
import { Tooltip } from 'react-tooltip';

import './TooltipMessage.style.scss';

export type TooltipPosition = 'top' | 'bottom';

type TooltipMessageProps = {
  /** Matches the anchor's `data-tooltip-id`; the inline copy uses `${id}-message` for aria-describedby. */
  id: string;
  content: string;
  position?: TooltipPosition;
};

export const tooltipMessageId = (id: string) => `${id}-message`;

// Desktop: floating tooltip with fixed positioning so it escapes overflow
// containers (e.g. SideScrollElement). Mobile: the same copy rendered inline,
// since hover isn't available on touch.
function TooltipMessage({
  id,
  content,
  position = 'bottom'
}: TooltipMessageProps) {
  return (
    <>
      <Tooltip
        id={id}
        className='TooltipMessage-popover'
        classNameArrow='TooltipMessage-arrow'
        place={position}
        positionStrategy='fixed'
        opacity={1}
        content={content}
      />
      <span
        id={tooltipMessageId(id)}
        className='TooltipMessage-inline'
      >
        {content}
      </span>
    </>
  );
}

export default TooltipMessage;
